<template>
  <div>

    123456
  </div>
</template>
<script>
export default {
  name: 'redpacket',
  data() {
    return {};
  },
  created() {
    let that = this;
  },
  methods: {},
  mounted() {
    let that = this;

  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';


</style>



// WEBPACK FOOTER //
// src/components/mine/redpacket.vue